import { BoldButton } from '@components/core-ui/form-elements/buttons/Button/variations/BoldButton';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { GenericPageError } from '@components/core-ui/GenericPageError';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { SelectableMiniTeamCards } from '@components/TeamCards/SelectableMiniTeamCards';
import { useAPI } from '@providers/useAPI';
import { OrganizationTeamWithMembersResponseDto, WorkspacesService } from 'app/API';
import { useEffect, useState } from 'react';

import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { Content } from './AddTeamToWorkspaceModal/styles/Content';

type TProps = {
  orgSlug: string;
  workspaceSlug: string;
  onCancel: () => void;
  onSuccess: (selectedTeams: string[]) => void;
};

export const AddTeamToWorkspaceModal = ({ orgSlug, workspaceSlug, onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();
  const [availableTeams, setAvailableTeams] = useState<OrganizationTeamWithMembersResponseDto[]>([]);
  const [selectedTeams, setSelectedTeams] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    call(WorkspacesService.getAvailableTeams({ orgSlug, wsSlug: workspaceSlug })).then((data) => {
      setAvailableTeams(data);
      setIsLoading(false);
    });
  }, []);

  const handleSave = async () => {
    onSuccess(selectedTeams);
  };

  return (
    <ModalWrapper width="490px">
      {isLoading ? <AbsoluteSpinner overlay={true} /> : null}
      <ModalTitle>Assign Teams</ModalTitle>
      <Content>
        {!isLoading && !availableTeams.length ? <GenericPageError message="No teams available" /> : null}
        {!isLoading && !!availableTeams.length ? (
          <div className="max-h-96 overflow-y-auto">
            <ul className="flex flex-wrap">
              {availableTeams.map((team) => (
                <SelectableMiniTeamCards
                  selectedTeams={selectedTeams}
                  setSelectedTeams={setSelectedTeams}
                  key={team.id}
                  team={team}
                />
              ))}
            </ul>
          </div>
        ) : null}
        <div className="buttonContainer m-auto">
          <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
          <BoldButton onClick={handleSave}>Add</BoldButton>
        </div>
      </Content>
    </ModalWrapper>
  );
};
